import { render, staticRenderFns } from "./BoxSale.vue?vue&type=template&id=1699ea4c&scoped=true"
import script from "./BoxSale.vue?vue&type=script&lang=js"
export * from "./BoxSale.vue?vue&type=script&lang=js"
import style0 from "./BoxSale.vue?vue&type=style&index=0&id=1699ea4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1699ea4c",
  null
  
)

export default component.exports